import { StarDoodle } from "./doodles";

const ITEMS = [
    "Good Music",
    "Good Energy",
    "No Gatekeeping",
    "Independent Sound",
    "Real Community",
    "Press Play & Stay Awhile",
];

const Row = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="mx-7 whitespace-nowrap font-condensed text-2xl font-extrabold uppercase tracking-wide text-ink">
                    {item}
                </span>
                <StarDoodle className="h-5 w-5 shrink-0" />
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <div
            data-testid="station-marquee"
            className="overflow-hidden border-y-[2.5px] border-ink bg-sunny py-3"
        >
            <div className="flex w-max animate-marquee">
                <Row hidden={false} />
                <Row hidden={true} />
            </div>
        </div>
    );
}
